import { FC } from 'react';
import ReactContentLoader from 'react-content-loader';

const handleLoderColor = (color) => {
    switch (color) {
        case 'loader500':
            return '#eeeeee66';
        case 'loader900':
        default:
            return '#eeeeee';
    }
};

const ContentLoader = ({ children, topBottom = false, color, ...rest }) => (
    <ReactContentLoader
        gradientDirection={topBottom ? 'top-bottom' : 'left-right'}
        backgroundColor={handleLoderColor(color)}
        foregroundOpacity={0.3}
        {...rest}
    >
        {children}
    </ReactContentLoader>
);

export default ContentLoader;
